import React, { useState } from 'react';

export default function CopyButton({ text, label = 'Copy', size = 'sm' }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const pad = size === 'sm' ? '4px 10px' : '7px 16px';
  const fs  = size === 'sm' ? 12 : 13;

  return (
    <button onClick={copy} style={{
      padding: pad, borderRadius: 6, fontSize: fs, fontWeight: 600,
      cursor: 'pointer', fontFamily: 'inherit', transition: 'all 0.15s',
      border: copied ? '1px solid #BBF7D0' : '1px solid var(--border)',
      background: copied ? '#F0FDF4' : 'var(--surface)',
      color: copied ? '#16A34A' : 'var(--text-2)',
      whiteSpace: 'nowrap',
    }}>
      {copied ? '✓ Copied' : label}
    </button>
  );
}
